import { Suspense } from 'react'
import { HeroUIProvider } from '@heroui/react'
import { ToastProvider } from '@heroui/toast'
import { Spinner } from '@heroui/react'

import { ErrorBoundary } from '../components/ErrorBoundary'
import {
  AdminDashboard,
  AlgoliaManagement,
  RecommendationLogsViewer,
  AnalyticsViewer,
  RecommendationTesting,
  UseCaseAnalytics,
  MediaManagement,
  UserManagement,
  EvalDashboard,
  EvalFixtureBuilder,
  RetrievalReviewPage,
  QuickAddPopup,
} from '../features/admin'
import { SearchProvider } from '../features/gifs/contexts/SearchProvider'

// Loading fallback component
export const PageLoader = () => (
  <div className="flex justify-center items-center min-h-screen">
    <Spinner size="lg" />
  </div>
)

// Wrapper for lazy components
export const LazyWrapper = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<PageLoader />}>{children}</Suspense>
)

// Root layout with providers
export const RootLayout = ({ children }: { children: React.ReactNode }) => (
  <ErrorBoundary showTechnicalDetails={false}>
    <HeroUIProvider>
      <ToastProvider placement="bottom-right" />
      <SearchProvider>{children}</SearchProvider>
    </HeroUIProvider>
  </ErrorBoundary>
)

// Admin Dashboard wrapper with navigation props
export const AdminDashboardWrapper = () => {
  const handleNavigate = (
    page:
      | 'algolia'
      | 'logs'
      | 'analytics'
      | 'testing'
      | 'use-cases'
      | 'media-management'
      | 'user-management'
      | 'eval'
      | 'eval-fixtures'
      | 'curation'
  ) => {
    window.location.href = `/admin/${page}`
  }

  return <AdminDashboard onNavigate={handleNavigate} />
}

export const EvalDashboardWrapper = () => {
  return <EvalDashboard />
}

export const EvalFixtureBuilderWrapper = () => {
  return <EvalFixtureBuilder />
}

export const RetrievalReviewWrapper = () => {
  return <RetrievalReviewPage />
}

export const QuickAddPopupWrapper = () => {
  return <QuickAddPopup />
}

// Admin component wrappers
export const AlgoliaManagementWrapper = () => {
  return <AlgoliaManagement />
}

export const RecommendationLogsWrapper = () => {
  return <RecommendationLogsViewer />
}

export const AnalyticsViewerWrapper = () => {
  return <AnalyticsViewer />
}

export const RecommendationTestingWrapper = () => {
  return <RecommendationTesting />
}

export const UseCaseAnalyticsWrapper = () => {
  return <UseCaseAnalytics />
}

export const MediaManagementWrapper = () => {
  return <MediaManagement />
}

export const UserManagementWrapper = () => {
  return <UserManagement />
}
